import React from "react";
import ReactApexChart from "react-apexcharts";

const chartData = [41, 24, 12, 30];

const chartOptions = {
  labels: ["Appointment", "News", "Message", "Team"],
  plotOptions: {
    pie: {
      donut: {
        labels: {
          show: true,
          total: {
            show: true,
            label: "Total",
            formatter: (w) => w.globals.seriesTotals.reduce((a, b) => a + b, 0),
          },
        },
      },
    },
  },
};

const DonutChart = () => (
  <ReactApexChart
    options={chartOptions}
    series={chartData}
    type="donut"
    width="100%"
    height="100%"
  />
);

export default DonutChart;
